import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const TitleContainers = styled(FlexContainer)`
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    display: none;
  }
`;
